import React, { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useCart } from "@/contexts/CartContext";
import { api, fileUrl } from "@/lib/api";
import { Link, useNavigate } from "react-router-dom";
import ProductCard from "@/components/ProductCard";

export default function Account() {
  const { user, logout, loading } = useAuth();
  const { recentlyViewed } = useCart();
  const [wishlist, setWishlist] = useState([]);
  const nav = useNavigate();
  useEffect(() => { if (!loading && !user) nav("/auth"); }, [user, loading, nav]);
  useEffect(() => { if (user) api.get("/wishlist").then(r=>setWishlist(r.data.items)).catch(()=>{}); }, [user]);
  if (!user) return null;
  return (
    <div className="max-w-6xl mx-auto px-6 py-12" data-testid="account-page">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-display text-5xl text-[color:var(--hb-navy)]">Hi, {user.name}</h1>
          <p className="text-sm text-neutral-500">{user.email}{user.is_admin && " · Admin"}</p>
        </div>
        <div className="flex gap-3">
          {user.is_admin && <Link to="/admin" className="hb-btn-secondary" data-testid="link-admin">Admin</Link>}
          <button onClick={logout} className="hb-btn-secondary" data-testid="logout-btn">Sign Out</button>
        </div>
      </div>

      <h2 className="font-display text-3xl text-[color:var(--hb-navy)] mb-4">Wishlist</h2>
      {wishlist.length === 0 ? <p className="text-sm text-neutral-500">Your wishlist is empty.</p> : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">{wishlist.map(p=><ProductCard key={p.product_id} product={p}/>)}</div>
      )}

      <h2 className="font-display text-3xl text-[color:var(--hb-navy)] mt-12 mb-4">Recently Viewed</h2>
      {recentlyViewed.length === 0 ? <p className="text-sm text-neutral-500">Browse products to see them here.</p> : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">{recentlyViewed.map(p=><ProductCard key={p.product_id} product={p}/>)}</div>
      )}
    </div>
  );
}
